<template>
  <div class="container clearfix">
    <Header />

    <div id="content" class="clearfix">
      <router-view/>
    </div>

    <Footer />
  </div>
</template>

<script>
  import Header from './components/Header.vue'
  import Footer from './components/Footer.vue'

  export default {
    components: {
      Header,
      Footer,
    },

    metaInfo: {
      title: 'Appsy',
      titleTemplate: '%s | Appsy'
    },
  };
</script>
